<template>
  <div class="summary-item-thumb" :data-qa="qaPrefix + '-item-' + item.article">
    <div class="summary-item-thumb-frame">
      <img
        v-if="item.imageUrl && !failed"
        class="summary-item-thumb-img"
        :src="item.imageUrl"
        :alt="item.name || item.article"
        loading="lazy"
        @error="failed = true"
      />
      <div v-else class="summary-item-thumb-placeholder">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L3 6.5V17.5L12 22L21 17.5V6.5L12 2Z"
            stroke="#DCDCDC"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <path
            d="M3 6.5L12 11L21 6.5M12 11V22"
            stroke="#DCDCDC"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <span
      v-if="item.quantity > 1"
      class="summary-item-thumb-qty"
      :data-qa="qaPrefix + '-item-qty-' + item.article"
      >{{ item.quantity }}</span
    >
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  item: {
    type: Object,
    required: true,
  },
  qaPrefix: {
    type: String,
    required: true,
  },
})

const failed = ref(false)
</script>

<style scoped lang="scss">
.summary-item-thumb {
  position: relative;
  width: 100%;
  min-width: 0;
  aspect-ratio: 74 / 64;
}

.summary-item-thumb-frame {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 2px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #8e9aa4;
  border-radius: 4px;
}

.summary-item-thumb-img,
.summary-item-thumb-placeholder {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 2px;
}

.summary-item-thumb-img {
  display: block;
  object-fit: cover;
  object-position: center;
}

.summary-item-thumb-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}

.summary-item-thumb-qty {
  position: absolute;
  top: -6px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 20px;
  box-sizing: border-box;
  padding: 2px 8px;
  border-radius: 999px;
  background: #54941e;
  color: rgba(255, 255, 255, 0.84);
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: -0.014em;
}
</style>
